/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { SupplierUserContext } from '@gh/supplier-shared';
import { SupplierCalendarRestService } from '@gh/supplier-shared-data';
import * as i0 from "@angular/core";
import * as i1 from "@gh/supplier-shared";
import * as i2 from "@gh/supplier-shared-data";
var SupplierCalendarBusinessService = /** @class */ (function () {
    function SupplierCalendarBusinessService(userContext, restService) {
        this.userContext = userContext;
        this.restService = restService;
    }
    SupplierCalendarBusinessService.prototype.getCalendarItems = function (year, month, officeId) {
        return this.restService.getAll({ officeId: officeId, year: year, month: month });
    };
    SupplierCalendarBusinessService.ɵfac = function SupplierCalendarBusinessService_Factory(t) { return new (t || SupplierCalendarBusinessService)(i0.ɵɵinject(i1.SupplierUserContext), i0.ɵɵinject(i2.SupplierCalendarRestService)); };
    SupplierCalendarBusinessService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierCalendarBusinessService, factory: SupplierCalendarBusinessService.ɵfac });
    return SupplierCalendarBusinessService;
}());
export { SupplierCalendarBusinessService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierCalendarBusinessService, [{
        type: Injectable
    }], function () { return [{ type: i1.SupplierUserContext }, { type: i2.SupplierCalendarRestService }]; }, null); })();
